import React, { PureComponent } from "react";
import _ from "lodash";
import { Button, SocialList, Image } from "../components";
import { withRedux } from "../hoc";

const menus = [
  { title: "Home", link: "/" },
  { title: "About", link: "/about" },
  { title: "Casting & Recruitment", link: "/career" },
  { title: "News", link: "/news" },
  // { title: "Purchase Tickets", link: process.env.REACT_APP_LINK_WEBSITE },
  { title: "Events", link: "/event" },
  { title: "Our Show", link: "/show" },
  { title: "Contact Us", link: "/contact" },
  { title: "Promotions", link: "/promotion" },
];

const contactInfo = {
  en: (
    <p className="menubar-margin">
      Tiffany’s show theatre is available for rental and hire for theatrical
      Events. Please contact our marketing department by phone at{" "}
      <small>
        <a href="tel:(+66)38-421-700">(+66) 38-421-700 to 5</a>
      </small>
      or by Email at{" "}
      <small>
        <a href="mailto:pr@tiffany-show.co.th">pr@tiffany-show.co.th</a>
      </small>{" "}
    </p>
  ),
  th: (
    <p className="menubar-margin">
      โรงละครทิฟฟานี่โชว์ พัทยา เปิดให้เช่าเพื่อจัดงานในโอกาสพิเศษต่างๆ
      สอบถามรายละเอียดเพิ่มเติมได้ที่แผนกการตลาด โทร{" "}
      <small>
        <a href="tel:038-421-700-5">038-421-700-5</a>
      </small>{" "}
      หรือ อีเมลล์{" "}
      <small>
        <a href="mailto:pr@tiffany-show.co.th">pr@tiffany-show.co.th</a>
      </small>{" "}
      และ{" "}
      <small>
        <a href="mailto:tiffany@tiffany-show.co.th">
          tiffany@tiffany-show.co.th
        </a>
      </small>
    </p>
  ),
  cn: (
    <p className="menubar-margin">
      蒂芬妮剧院为表演活动提供租用服务，请致电
      <small>
        <a href="tel:(+66)38-421-700-5">(+66)38-421-700~5</a>
      </small>
      或通过电子邮件
      <small>
        <a href="mailto:pr@tiffany-show.co.th">pr@tiffany-show.co.th</a>
      </small>
      与我们的营销部门联系。
    </p>
  ),
};

const mapStateToProps = (state) => {
  return {
    contact: _.get(state, "contact.data"),
    t: _.get(state, "t"),
    language: _.get(state, "language"),
  };
};

@withRedux(mapStateToProps)
export default class Footer extends PureComponent {
  render() {
    const { contact, t } = this.props;
    const ourPartners = _.get(contact, "media_our_partners_data");

    return (
      <footer>
        <div className="container">
          <div className="container-border">
            <div className="row">
              <div className="col-sm-6 col-md-4">
                <div className="menubar">
                  <h3>Tiffany’s Show</h3>
                  <div className="row menubar-margin">
                    {_.map(menus, (menu) => {
                      return (
                        <div className="col-6" key={_.get(menu, "title")}>
                          <a href={_.get(menu, "link")}>
                            {t(_.get(menu, "title"))}
                          </a>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4">
                <div className="contact">
                  <h3>{t("Reservation")}</h3>
                  {t(contactInfo)}
                  <a href={`${window.location.origin}/booking`}>
                    <Button type="primary" style={{ marginTop: 28 }}>
                      {t("Purchase Tickets")}
                    </Button>
                  </a>
                </div>
              </div>
              <div className="col-md-4">
                <h3>{t("Our Partners")}</h3>
                <div className="partner-logo">
                  {_.map(ourPartners, (logo, key) => {
                    return (
                      <Image
                        src={_.get(logo, "full_file_path")}
                        alt=""
                        key={key}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bar">
            <div className="row align-items-center">
              <div className="col-md-auto mr-auto">
                <div className="copyright">
                  <p>© Copyright 2018 Tiffany’s Show. All Rights Reserved.</p>
                </div>
              </div>
              <div className="col-md-auto">
                <div className="container-social-link">
                  <SocialList />
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js